import { render } from "./AppAlerts.vue?vue&type=template&id=2f54037e&scoped=true"
import script from "./AppAlerts.vue?vue&type=script&lang=js"
export * from "./AppAlerts.vue?vue&type=script&lang=js"

import "./AppAlerts.vue?vue&type=style&index=0&id=2f54037e&scoped=true&lang=css"

import exportComponent from "../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f54037e"]])

export default __exports__